/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, Paper, TextField } from "@mui/material";
import { DataGrid, GridToolbarFilterButton } from "@mui/x-data-grid";
import { addNewPaymentMethod, editPaymentMethod, getPaymentMethods } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";

const PaymentMethod = () => {
    const {state} = useAuth();
    const [paymentMethods, setPaymentMethods] = useState<any>([]);

    const handleAddRow = () => {
        const newRow = {
            id: paymentMethods.length + 1,
            paymentMethodName: ``,
        };
        setPaymentMethods((prevRows: any) => [newRow, ...prevRows]);
    };

    const handleChange = (id: any, field: any, newValue: any) => {
        const updatedRows = paymentMethods.map((row: any) =>
          row.id === id ? { ...row, [field]: newValue } : row
        );
        setPaymentMethods(updatedRows);
    };

    useEffect(() => {
        getPaymentMethods(state.user?.token).then(setPaymentMethods);
    }, [])

    const columns: any = [
        {
            field: "paymentMethodName",
            headerName: "Name",
            flex: 1,
            renderCell: (params: any) => (
                <TextField
                    size="small"
                    value={params.row.paymentMethodName}
                    style={{margin: 5}}
                    fullWidth
                    onChange={(event: any) => {
                        handleChange(params.id, "paymentMethodName", event.target.value);
                    }}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (event) => {
                          if (event.key === ' ') {
                            event.stopPropagation();
                          }
                        },
                    }}
                />
            ),
        },
        {
            field: "displayName",
            headerName: "Display Name",
            flex: 1,
            renderCell: (params: any) => (
                <TextField
                    size="small"
                    value={params.row.displayName}
                    style={{margin: 5}}
                    fullWidth
                    onChange={(event: any) => {
                        handleChange(params.id, "displayName", event.target.value);
                    }}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (event) => {
                          if (event.key === ' ') {
                            event.stopPropagation();
                          }
                        },
                    }}
                />
            ),
        },
        {
            field: "createdDate",
            headerName: "Created Date",
            flex: 0.4,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.createdDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "SAVE",
            headerName: "Save",
            flex: 0.4,
            renderCell: (params: any) => (
                <Button variant="outlined" onClick={()=> handleCellEditCommit(params)}>Save</Button>
            )
        },
    ];

    const handleCellEditCommit = async (params: any) => {
        if(typeof params.row.id === 'number') {
            const response = await addNewPaymentMethod(
                state.user?.token,
                params.row.paymentMethodName,
                params.row.displayName
            )
            if(response) {
                toast.success(response.data);
            }else {
                toast.error('Something went wrong!')
            }
        } else {
            const response = await editPaymentMethod(
              state.user?.token,
              params.row.id,
              params.row.paymentMethodName,
              params.row.displayName
            );
            if(response) {
                toast.success(response.data);
            }else if(response === 403) {
                toast.error('You are not authorized!')
            }
        }
    };

    const Toolbar = () => {
        return (
            <div>
                <GridToolbarFilterButton />
            </div>
        );
    };

    return (
        <Box sx={{ 
            p: 1,
            height: '100%',
            minHeight: '100vh'
        }}>
            <Paper 
                elevation={0} 
                sx={{ 
                    p: 3, 
                    borderRadius: '16px',
                    backgroundColor: '#ffffff',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mb: 3 
                }}>
                    <Box>
                        <h1 style={{ 
                            margin: 0, 
                            fontSize: '1.5rem', 
                            fontWeight: 600,
                            color: '#0f172a'
                        }}>
                            Payment Methods
                        </h1>
                        <p style={{ 
                            margin: '4px 0 0', 
                            color: '#64748b',
                            fontSize: '0.875rem'
                        }}>
                            Configure payment options available
                        </p>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={handleAddRow}
                        style={{boxShadow: 'none'}}
                    >
                        New Payment Method
                    </Button>
                </Box>

                <Box
                    sx={{ 
                        width: "100%",
                        height: 700,
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            margin: "0 auto",
                            "@media (max-width: 800px)": {
                                overflowX: "auto",
                                margin: 1,
                                minWidth: "95%",
                            },
                        }}
                    >
                        <DataGrid
                            rows={paymentMethods}
                            columns={columns}
                            slots={{ toolbar: Toolbar }}
                            disableRowSelectionOnClick
                            sx={{
                                "@media (max-width: 700px)": {
                                    minWidth: "100%",
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    color: "#333",
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    backgroundColor: '#f0f0f0',
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold",
                                },
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "#f1f1f1",
                                },
                            }}
                        />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default PaymentMethod;
